import { ReactNode } from "react";
import TooltipTrigger from "../../tooltip-trigger";
import "./status-badge-view.scss";

//<editor-fold desc="Props">
export interface StatusBadgeItem {
  tip: ReactNode | string;
  badgeStyle: string;
  label: ReactNode | string;
  icon?: ReactNode;
}

export interface StatusBadgeProps {
  item: StatusBadgeItem;
  withLabel?: boolean;
}
//</editor-fold>

function StatusBadge(props: StatusBadgeProps) {
  //<editor-fold desc="Local variables">
  let { item, withLabel, ...others } = props;
  return (
    <TooltipTrigger
      tipKey={"status-badge-tip"}
      tip={item.tip}
      delay={{ show: 900, hide: 100 }}
      placement={"top"}
    >
      <span className={"status-badge " + item.badgeStyle} {...others}>
        {!!item.label && (<>
          <span className={"badge-icon"}></span>
          {withLabel && <span className={"badge-label"}>{item.label}</span>}
        </>)}
      </span>
    </TooltipTrigger>
  );
}
export default StatusBadge;
